import { useCallback, useLayoutEffect, useState } from 'react'

type UseMeasureResult = [
    (node: HTMLDivElement | null) => void,
    { width: number; height: number },
    HTMLDivElement | null,
]

export const useMeasure = (): UseMeasureResult => {
    const [element, setElement] = useState<HTMLDivElement | null>(null)
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

    const ref = useCallback((node: HTMLDivElement | null) => {
        setElement(node)
    }, [])

    useLayoutEffect(() => {
        if (!element) return

        const observer = new ResizeObserver(([entry]) => {
            if (!entry) return
            const { width, height } = entry.contentRect
            setDimensions({ width, height })
        })

        observer.observe(element)
        setDimensions({ width: element.offsetWidth, height: element.offsetHeight })

        return () => observer.disconnect()
    }, [element])

    return [ref, dimensions, element]
}
